import React, { useState, useEffect, useRef, useCallback } from "react";
import * as Mui from "@mui/material";
import { useFetch } from "services/hooks/useFetch";
import {
  themes,
  scrollTop,
  drawerStyle,
  tableRowSize,
  stickyHeader,
  // defaultAllSelection,
} from "services/constants";
import { useSelector } from "react-redux";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { Loader } from "components/Loader";
import { Typography, Box, Paper, Drawer, Tooltip } from "@mui/material";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { CustomButton } from "components/CustomComponents";
import { showToast } from "services/utils/Status";
import { NewSalaryComponent } from "./NewSalaryComponent";
import { ViewSalaryComponent } from "./ViewSalaryComponent";
import { StatusType } from "services/constants";
import { salaryComponentHeader } from "pages/HR/Headers";
import {
  CheckCircleOutline,
  HighlightOff,
  PeopleAlt,
} from "@mui/icons-material";
import { tooltipStyleProps } from "services/constants/Styles";

export const SalaryComponent = ({ setSalaryConfigItem }) => {
  const { domain, userScreenAccess, topbarCompanyId } = useSelector(
    (state) => state.tokenReducer
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [salaryComponentDetails, setSalaryComponentDetails] = useState([]);
  const containerRef = useRef(null);
  const [individualComponentData, setIndividualComponentData] = useState([]);
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Salary Configuration",
    "Salary Component"
  );

  const {
    result: salaryComponentData,
    setLoad: reCallApi,
    loading,
  } = useFetch(
    `${domain}HRZone/Salary/Salary_Component/salary-component-list/?company_id=${topbarCompanyId}`
  );
  const [isCreatePanelOpen, setIsCreatePanelOpen] = useState(false);
  const [isViewPanelOpen, setIsViewPanelOpen] = useState(false);
  const [hanldeLoader, setHanldeLoader] = useState(false);
  const [getId, setGetId] = useState("");

  const hanldeCreatePanel = () => {
    setIsCreatePanelOpen(true);
  };

  const handleViewPanel = () => {
    setIsViewPanelOpen(true);
  };

  const handleCreateClosePanel = () => {
    setIsCreatePanelOpen(false);
  };

  const handleViewClosePanel = () => {
    setIsViewPanelOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  useEffect(() => {
    if (salaryComponentData?.data?.length > 0 && hanldeLoader) {
      const item = salaryComponentData?.data?.find((d) => d.id === getId);
      setIndividualComponentData(item);
    }
  }, [getId, hanldeLoader, salaryComponentData?.data]);

  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      setSalaryComponentDetails(filteredData);
      if (page * rowsPerPage >= filteredData.length) setPage(0);
    },
    [page, rowsPerPage]
  );

  const NewPayrunButton = (
    <CustomButton
      actionFuntion={() => {
        if (check_access) {
          hanldeCreatePanel();
        } else {
          showToast(
            "error",
            "Access denied: You are not authorized to create salary component"
          );
        }
      }}
      actionName="New"
      typeName="button"
    />
  );

  useEffect(() => {
    if (topbarCompanyId) {
      reCallApi(true);
      setHanldeLoader(false);
    }
  }, [reCallApi, topbarCompanyId]);

  return !hanldeLoader && loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            mb: 1,
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Salary Component
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Define individual parts of the salary.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mr: 2 }}>
            <Tooltip
              title="Move to salary component Assignment"
              arrow
              slotProps={tooltipStyleProps}
            >
              <Mui.IconButton
                size="small"
                sx={{
                  bgcolor: themes?.whiteColor,
                  borderRadius: 1,
                  border: `1px solid ${themes?.mutedgreen}`,
                  width: 34,
                  height: 34,
                  mt: 0.5,
                }}
                onClick={() => setSalaryConfigItem("Group Salary Component")}
              >
                <PeopleAlt
                  sx={{ fontSize: 18, color: themes?.softMutedGreen }}
                />
              </Mui.IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Paper sx={{ width: "100%", height: "78vh" }}>
          <CustomFilter
            title={"Salary Component Records"}
            filterHeaders={salaryComponentHeader}
            data={salaryComponentData?.data}
            filteredData={salaryComponentDetails}
            onFilteredDataChange={handleFilteredDataChange}
            screenAccess={check_access}
            newButtonComponent={NewPayrunButton}
          />

          <Mui.Grid sx={{ ml: 2, mr: 2 }}>
            <Mui.TableContainer ref={containerRef} sx={{ maxHeight: 590 }}>
              <Mui.Table className="border">
                <Mui.TableHead sx={stickyHeader}>
                  <Mui.TableRow sx={tableRowSize}>
                    {salaryComponentHeader?.map((value) => (
                      <Mui.TableCell
                        sx={{
                          color: themes.headLine,
                          fontWeight: "bold",
                        }}
                      >
                        {value?.name}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {salaryComponentDetails?.length === 0 ? (
                    <InfoMessage dataLength={salaryComponentData?.data} />
                  ) : (
                    salaryComponentDetails
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((value) => (
                        <Mui.TableRow sx={tableRowSize}>
                          {salaryComponentHeader.map((head) => (
                            <Mui.TableCell
                              onClick={() => {
                                handleViewPanel();
                                setIndividualComponentData(value);
                              }}
                            >
                              {head.key === "component_category" ? (
                                <span
                                  style={StatusType(
                                    value?.component_category,
                                    value?.category_color
                                  )}
                                >
                                  {value.component_category}
                                </span>
                              ) : value[head.key]?.value !== undefined ||
                                typeof value[head.key] === "boolean" ? (
                                value[head.key]?.value ?? value[head.key] ? (
                                  <CheckCircleOutline
                                    style={{ color: "green" }}
                                  />
                                ) : (
                                  <HighlightOff style={{ color: "red" }} />
                                )
                              ) : (
                                value[head.key] ?? "0"
                              )}
                            </Mui.TableCell>
                          ))}
                        </Mui.TableRow>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
            <Box sx={{ mt: 1 }}>
              {salaryComponentDetails?.length > 25 && (
                <Mui.TablePagination
                  className="custom-pagination"
                  component="div"
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  count={salaryComponentDetails?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Box>
          </Mui.Grid>
        </Paper>
      </Box>
      <Drawer
        anchor="right"
        open={isCreatePanelOpen || isViewPanelOpen}
        onClose={() => {
          isCreatePanelOpen ? handleCreateClosePanel() : handleViewClosePanel();
        }}
        sx={drawerStyle}
      >
        {isCreatePanelOpen ? (
          <NewSalaryComponent
            onClose={handleCreateClosePanel}
            reCallApi={reCallApi}
            setHanldeLoader={setHanldeLoader}
          />
        ) : (
          <ViewSalaryComponent
            onClose={handleViewClosePanel}
            individualComponentData={individualComponentData}
            reCallApi={reCallApi}
            setGetId={setGetId}
            setHanldeLoader={setHanldeLoader}
            screenAccess={check_access}
          />
        )}
      </Drawer>
    </React.Fragment>
  );
};
